import { Component, inject, Input, type OnInit } from '@angular/core';
import type { TitleUpdate } from '../../../server/types/message-types';
import { AuthUserService } from '../auth-user.service';

@Component({
  selector: 'app-thread-title-update-display',
  templateUrl: './thread-title-update-display.component.html',
  styleUrls: ['./thread-title-update-display.component.scss'],
  standalone: false,
})
export class ThreadTitleUpdateDisplayComponent implements OnInit {
  private authUserService = inject(AuthUserService);

  @Input() orgId: string;
  @Input() update: TitleUpdate;

  updaterName = '';
  title = '';

  ngOnInit(): void {
    this.updaterName = this.name(this.update.updatedBy);
    this.title = this.update.title;
  }

  private name(userId: string) {
    return (
      this.authUserService.getUser({
        orgId: this.orgId,
        userId,
      })?.name ?? 'Unknown user'
    );
  }
}
